(function ($) {
    if (!$) {
        return;
    }

    $.fn.loadSpinner = function () {
        let loadSpinners = $.grep($(this).toArray(), function (element) {
            return $(element).hasClass("load-spinner");
        });
        if (!loadSpinners.length) {
            return [];
        }

        loadSpinners = $.grep(loadSpinners, function (element) {
            return $(".spinner-container", element).length > 0;
        });
        
        const apis = [];
        $.each(loadSpinners, function () {
            const $loadSpinner = $(this);

            let api = $loadSpinner.data("loadSpinner");
            if (api) {
                apis.push(api);
                return;
            }

            $(".spinner-container", $loadSpinner).prepend(app.spinner);

            api = {
                show: function (callback) {
                    if (callback) {
                        $loadSpinner.one("animationend", callback);
                    }
                    $loadSpinner.addClass("show");
                },
                hide: function (callback) {
                    if (callback) {
                        $loadSpinner.one("animationend", callback);
                    }
                    $loadSpinner.one("animationend", function () {
                        $(this).removeClass("show").removeClass("shown").removeClass("hide");
                    });
                    $loadSpinner.addClass("hide");
                },
                isVisible: function () {
                    return ($loadSpinner.hasClass("show") || $loadSpinner.hasClass("shown")) && !$loadSpinner.hasClass("hide");
                }
            };

            $loadSpinner.data("loadSpinner", api);
            apis.push(api);
        });

        return apis;
    };
})(jQuery);
